type StaggerState = {
  index: number;
  lastAt: number;
};

const staggers = new Map<string, StaggerState>();

// Exponentially reduce per-item stagger as more triggers fire within the window.
export const getStaggerDelay = (
  key: string,
  step = 0.35,
  resetAfterMs = 1500,
  decay = 0.8
) => {
  const now = Date.now();
  const state = staggers.get(key) ?? { index: 0, lastAt: 0 };
  if (now - state.lastAt > resetAfterMs) {
    state.index = 0;
  }

  const i = state.index;
  const delay = step * (1 - Math.pow(decay, i)) / (1 - decay);

  state.index += 1;
  state.lastAt = now;
  staggers.set(key, state);
  return delay;
};
